'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.purchaseALaCarte = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _sagaTools = require('@classpass/saga-tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var purchaseALaCarte = exports.purchaseALaCarte = (0, _sagaTools.makeEntityScaffold)('SAGA.API.PURCHASE_ALC', function (client, stripeToken, scheduleId, postalCode, conversion) {
  return client.users.purchaseALaCarte((0, _extends3.default)({
    alc_schedule_id: scheduleId,
    payment_token: stripeToken,
    billing_info: {
      address: {
        postal_code: postalCode
      }
    }
  }, conversion && (0, _keys2.default)(conversion).length && { conversion: conversion }));
}); /* eslint-disable import/prefer-default-export */